import React, { useEffect, useState } from "react";
import "../Popup/AddComponentPopup.scss";
import { useDispatch } from "react-redux";
import { createComponent, createElement, getPopulatedComponent, getPopulatedLayout, uploadImage } from "../../../core/actionCreators/lmsActionCreator";
import AddAttributeForm from "../Form/AddAttributeForm";
import { v4 as uuidv4 } from 'uuid';
import { useSelector } from "react-redux";
import { MdClose } from "react-icons/md";
import { RiDeleteBin4Fill } from "react-icons/ri";
import toast from "react-hot-toast";

const AddComponentPopup = (props: any) => {
    const dispatch = useDispatch()
    const { setAddComponentPopup, layoutId, componentId, page } = props
    let { user } = useSelector((s: any) => s.authStore);
    let { staticFormFields } = useSelector((s: any) => s.lmsStore);
    //Positions are 1 based on the layout page, so a new one starts at 1 rather than 0
    const [order, setOrder] = useState(1)
    const [componentName, setComponentName] = useState("")
    const [componentType, setComponentType] = useState("")
    const [msns, setMsns] = useState("")
    const [formAttributes, setFormAttributes] = useState([{
        "id": uuidv4(),
        "attributeKeyId": "",
        "attributeValue": ""
    }])
    const [currentPage, setCurrentPage] = useState("")


    useEffect(() => {
        setCurrentPage(page)
    }, [props, page])

    const addFieldHandler = () => {
        setFormAttributes([...formAttributes, {
            "id": uuidv4(),
            "attributeKeyId": "",
            "attributeValue": ""
        }])
    }

    const removeFieldHandler = (id: string) => {
        const filteredFields = formAttributes.filter((d) => d.id !== id)
        setFormAttributes([...filteredFields])
    }


    const addClickHandler = () => {
        const attributes = formAttributes.map((d) => {
            return {
                "attributeKeyId": d["attributeKeyId"],
                "attributeValue": d["attributeValue"]
            }
        })

        //Caught here so the form is not lost to a backend rejection
        if (page === "LAYOUT" && !componentName.trim()) {
            toast.error("Component name is required.")
            return
        }
        if (componentType === "product" && !msns.trim()) {
            toast.error("Add at least one MSN for a product component.")
            return
        }
        if (componentType !== "product" && attributes.some((a: any) => !a.attributeKeyId || !a.attributeValue)) {
            toast.error("Every field needs a key and a value, remove the empty ones.")
            return
        }

        if (page === "LAYOUT") {
            const imageUploadActions = attributes.filter((d: any) => [27, 28].includes(d["attributeKeyId"]))
            if (imageUploadActions.length > 0) {
                if (imageUploadActions.length == 2) {
                    let index = attributes.findIndex((d: any) => d.attributeKeyId === imageUploadActions[0]["attributeKeyId"])
                    let formData = new FormData();
                    formData.append("file", imageUploadActions[0]["attributeValue"])
                    dispatch(uploadImage(formData, (res: any) => {
                        attributes[index]["attributeValue"] = res.s3ImageUrl
                        index = attributes.findIndex((d: any) => d.attributeKeyId === imageUploadActions[1]["attributeKeyId"])
                        formData.append("file", imageUploadActions[1]["attributeValue"])
                        dispatch(uploadImage(formData, (res1: any) => {
                            attributes[index]["attributeValue"] = res1.s3ImageUrl
                            let requestPayload = {
                                "component": {
                                    "componentName": componentName,
                                    "componentType": componentType,
                                    "isParentStructure": false,
                                    "childComponentId": "",
                                    "status": true
                                },
                                "msns": msns,
                                "attributes": (componentType === "product") ? null : attributes,
                                "modifiedBy": user.id || -1,
                                "order": order,
                                "layoutId": layoutId
                            }
                            setAddComponentPopup(false)
                            let callback = () => {
                                dispatch(getPopulatedLayout(layoutId, null))
                            }
                            dispatch(createComponent(requestPayload, callback))
                        }))
                    }))
                }
                if (imageUploadActions.length == 1) {
                    const formData = new FormData();
                    formData.append("file", imageUploadActions[0]["attributeValue"]);
                    dispatch(uploadImage(formData, (res: any) => {
                        let index = attributes.findIndex((d: any) => d.attributeKeyId === imageUploadActions[0]["attributeKeyId"])
                        attributes[index]["attributeValue"] = res.s3ImageUrl
                        let requestPayload = {
                            "component": {
                                "componentName": componentName,
                                "componentType": componentType,
                                "isParentStructure": false,
                                "childComponentId": "",
                                "status": true
                            },
                            "msns": msns,
                            "attributes": (componentType === "product") ? null : attributes,
                            "modifiedBy": user.id || -1,
                            "order": order,
                            "layoutId": layoutId
                        }
                        setAddComponentPopup(false)
                        let callback = () => {
                            dispatch(getPopulatedLayout(layoutId, null))
                        }
                        dispatch(createComponent(requestPayload, callback))
                    }))
                }
                //The upload callbacks create the component once the URLs are back,
                //without this the raw File was also sent straight away as a second create
                return
            }
            let requestPayload = {
                "component": {
                    "componentName": componentName,
                    "componentType": componentType,
                    "isParentStructure": false,
                    "childComponentId": "",
                    "status": true
                },
                "msns": msns,
                "attributes": (componentType === "product") ? null : attributes,
                "modifiedBy": user.id || -1,
                "order": order,
                "layoutId": layoutId
            }
            setAddComponentPopup(false)
            let callback = () => {
                dispatch(getPopulatedLayout(layoutId, null))
            }
            dispatch(createComponent(requestPayload, callback))
        }
        if (page === "COMPONENT") {
            let requestPayload = {
                "element": {
                    "componentId": componentId,
                    "parentId": null,
                    "isDeleted": false,
                    "order": order
                },
                "attributes": attributes,
                "modifiedBy": user.id || -1
            }
            setAddComponentPopup(false)
            let callback = () => {
                dispatch(getPopulatedComponent(componentId, null))
            }
            dispatch(createElement(requestPayload, callback))
        }
    }

    const isLayoutPage = currentPage === "LAYOUT"
    const entity = isLayoutPage ? "Component" : "Element"

    return (
        <>
            <div className="popup-container side-panel">
                <div className="overlay" >
                    <div className="right-popup-content">
                        <div className="popup-content-inner">
                            <div className="popup-header flex items-start justify-between">
                                <div>
                                    <h2>Add {entity}</h2>
                                    <p className="text-xs">Fill in the below details..</p>
                                </div>
                                <button onClick={() => setAddComponentPopup(false)} title="Close" className="close-btn flex items-center justify-center">
                                    <MdClose size={18} />
                                </button>
                            </div>

                            <div className="right-form-container ">
                                <div className="form-section">
                                    <p className="form-section-title">{entity} details</p>

                                    <div className="form-field">
                                        <label>{entity} Name</label>
                                        <input required value={componentName} onChange={(e) => setComponentName(e.target.value)} type="text" placeholder={`Enter ${entity.toLowerCase()} name`} />
                                    </div>
                                    <div className="form-field">
                                        <label>{entity} Type</label>
                                        <select value={componentType} onChange={(e) => setComponentType(e.target.value)}>
                                            <option value={""} >Non Product</option>
                                            <option value={"product"} >Product</option>
                                        </select>
                                        <p className="field-hint">
                                            {componentType === "product"
                                                ? "Product components are filled from MSNs instead of attributes."
                                                : "Non product components are described by the attributes below."}
                                        </p>
                                    </div>
                                    <div className="form-field">
                                        <label>Order</label>
                                        <input className="order-input" min={1} value={order} onChange={(e) => setOrder(Number(e.target.value))} type="number"></input>
                                        <p className="field-hint">Position on the page, lower numbers render first.</p>
                                    </div>
                                </div>

                                {componentType === "" &&
                                    <div className="form-section">
                                        <div className="section-head flex items-center justify-between">
                                            <p className="form-section-title mb-0">Attributes ({formAttributes.length})</p>
                                            {/* One button for the whole list, it used to repeat under every field */}
                                            <button onClick={addFieldHandler} className="add-field py-1 font-semibold px-2">+ Add Field</button>
                                        </div>

                                        {formAttributes.map((d, index) =>
                                            <div key={d.id} className="attribute-card">
                                                <div className="attribute-card-head flex items-center justify-between">
                                                    <span className="attribute-index">Field {index + 1}</span>
                                                    <button
                                                        onClick={() => removeFieldHandler(d.id)}
                                                        disabled={formAttributes.length === 1}
                                                        title={formAttributes.length === 1 ? "At least one field is required" : "Remove this field"}
                                                        className="remove-field flex items-center justify-center">
                                                        <RiDeleteBin4Fill />
                                                    </button>
                                                </div>
                                                <AddAttributeForm
                                                    formAttribute={d}
                                                    formAtrributes={formAttributes}
                                                    setFormAttributes={setFormAttributes}
                                                    staticFormFields={staticFormFields} />
                                            </div>
                                        )}
                                    </div>
                                }

                                {componentType === "product" &&
                                    <div className="form-section">
                                        <p className="form-section-title">Products</p>
                                        <div className="form-field">
                                            <label>MSN's</label>
                                            <textarea onChange={(e) => setMsns(e.target.value)} value={msns} rows={10} placeholder="Enter comma separated MSNs">
                                            </textarea>
                                            <p className="field-hint">One or more MSNs, separated by commas.</p>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>

                        <div className="fix-bottom-btn-cta flex justify-end items-center">
                            <button onClick={() => setAddComponentPopup(false)} className="bg-transparent font-semibold text-slate-800  py-2 px-6">Cancel</button>
                            <button onClick={addClickHandler} className="bg-blue-500 text-white font-semibold rounded shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75 py-2 px-6">Add {entity}</button>
                        </div>

                    </div>
                </div>
            </div>

        </>
    );
};

export default AddComponentPopup;

